<template>
  <dialog-big
    :title="dialogTitle"
    :visible.sync="isVisibleDialog"
  >
    <div v-loading="this.isLoading">
      <form-editor
        :data="data"
        :model="popupModel"
        ref="Form"
        :rulesBaxPO="rulesBaxPO"
      >
        <template v-slot:right-info>
          <more-quotes-grid-chosen :listSelectedQuotes="selectedList" />
        </template>
      </form-editor>
      <div class="row">
        <div class="col-12">
          <slot name="info-content" />
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        isCancel
        isCreate
        @command="setCommand"
      >
        <div class="control btn-mobile-full">
          <button type="button" class="btn btn-border blue btn-size-s" @click="onFill('France')">
            {{L10n('stock-france')}}
          </button>
        </div>
        <div class="control btn-mobile-full" style="margin-right: auto">
          <button type="button" class="btn btn-border blue btn-size-s" @click="onFill('USA')">
            {{L10n('stock-usa')}}
          </button>
        </div>
      </form-controls>
    </template>
  </dialog-big>
</template>

<script>
import { ModelFrance, ModelSharedForm, ModelUSA, ServiceRFQs } from '@/services/RFQs'

export default {
  name: 'DialogCreatePoWo',
  components: {
    'form-editor': () => import(/* webpackChunkName: 'SupplierQuotesRFQ2' */ './Form.vue'),
    'dialog-big': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/DialogBig'),
    'more-quotes-grid-chosen': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQSupplierMoreQuotesGridChosen/Index.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    selectedList: { type: Array, required: true },
    actionName: { type: String, required: true },
    formModel: { type: Function },
    dataRFQ: { type: Object },
    updatePoDate: { type: Boolean, default: true }
  },
  data () {
    return {
      isVisibleDialog: false,
      isLoading: false,
      data: {}
    }
  },
  computed: {
    dialogTitle () {
      if (this.actionName === 'create-wo') {
        return this.L10n('create-wo')
      } else {
        return this.L10n('create-po')
      }
    },
    defaultRfqTypeID () {
      if (this.actionName === 'create-wo') {
        return 5
      } else if (this.actionName === 'create-supplier-po') {
        return 4
      } else {
        return 3
      }
    },
    rulesBaxPO () {
      if (this.actionName === 'create-wo') {
        return this.ruleActionWO
      } else if (this.actionName === 'create-supplier-po') {
        return this.ruleActionSupplierPO
      } else {
        return []
      }
    },
    ruleActionWO () {
      return [
        {
          validator: (rule, value, cb) => {
            const val = String(value)
            if (val.startsWith('W')) {
              cb()
            } else {
              cb(new Error(this.L10n('validation-rule-start-w')))
            }
          }
        }
      ]
    },
    ruleActionSupplierPO () {
      return []
    }
  },
  methods: {
    popupModel () {
      if (this.formModel) {
        return this.formModel()
      }
      return this.copyObjectProps(ModelSharedForm(), {
        rfqTypeID: this.defaultRfqTypeID
      })
    },
    onFill (country) {
      let fillModel = {}
      if (country === 'USA') {
        fillModel = ModelUSA()
      }
      if (country === 'France') {
        fillModel = ModelFrance()
      }
      this.data = { ...this.$refs.Form.getData(), ...fillModel }
    },
    show () {
      this.resetData()
      this.isVisibleDialog = true
    },
    setCommand (command) {
      switch (command) {
        case 'save':
          this.create()
          break
        case 'cancel':
          this.hide()
          break
      }
    },
    resetData () {
      this.data = {}
    },
    create () {
      let form = this.$refs['Form']
      form.validate()
        .then(() => {
          let dataPopup = this.data = { ...form.getData() }
          return this.requestCreatePO(dataPopup)
        })
    },
    hide () {
      this.isVisibleDialog = false
      this.resetData()
    },
    requestCreatePO (dataPopup) {
      this.isLoading = true
      ServiceRFQs
        .createPoWo({ dataRFQ: this.dataRFQ, sharedData: dataPopup, listRFQ2s: this.selectedList, updatePoDate: this.updatePoDate })
        .then(({ data }) => {
          this.requestSuccessHandler()
          this.$emit('onCreatedPO', data.rfq.id, data.salesOrder.id)
          this.hide()
        })
        .catch((error) => {
          this.requestErrorHandler(error)
        })
        .then(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
